import { TResponseFilter } from "@app/core/types/response.type";

export enum EGlobalSearchEntity {
  Client = "Client",
  Policy = "Policy",
  Invoice = "Invoice",
  Facility = "Facility",
  OperatingCompany = "OperatingCompany",
  AdditionalInsured = "AdditionalInsured",

  Claim = "Claim",
}

export interface IGlobalSearch {
  entityType: EGlobalSearchEntity;
  entityName: string;
  entityId: string;
  displayValue: string;
  createdAt: string;
  clientId: string;
}

export type TGlobalSearchResponse = TResponseFilter<IGlobalSearch>;

export interface IClaimSearchItem {
  id: string;
  number: string;
  claimantName: string | null;
}
